import { Fragment } from 'react';
import { TextField } from '@material-ui/core';
import './otp-field.scss';
import en from '../../lang/en-us';
import { useMemo, useState } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useCallback } from 'react';

import { NoteModals } from '../NoteModals';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { REGISTER_WITH_MOBILE } from '../../utils/constants';
import { maskMobileNumber } from '../../utils/utilityFunctions';
import { usePrevious } from '../../hooks/usePrevious';
const { common, dashboard } = en;
const OTP_LENGTH = 6;
export function OtpField({
    value: otp = new Array(6).fill(''),
    disabled = false,
    showModal,
    maskedInfo,
    _handleProceed = () => {},
    formik = {},
    ...props
}: any) {
    const ref = useRef<any>([]);
    const [isPasteData, setIsPasteData] = useState<boolean>(false);
    const { email, mobile, userRegisteredWith } = useSelector(({ authReducer }: RootStateType) => ({
        ...authReducer,
    }));

    const otpIdPrefix = useMemo(() => `otp-${Math.random().toString(36).slice(2, 10)}`, []);
    const groupLabelId = `${otpIdPrefix}-label`;

    useEffect(() => {
        if (ref.current.length) {
            ref.current[0].focus();
        }
    }, []);

    const otpChange = (value: string, index: number) => {
        //handle paste directly
        if (value.length === OTP_LENGTH) {
            const otpVal = value.replace(/\s+/g, ' ').trim();
            if (otpVal.length == 6 && !isNaN(+otpVal)) {
                const otpArr = otpVal.split('');
                props.updateValue(otpArr);
                ref.current[5].focus();
            }
            return;
        }
        if (!/^[\d ]*$/.test(value) || isPasteData) {
            setIsPasteData(false);
            return;
        }
        if ((value && !otp[index].length) || !value) {
            if (!!props.updateValue && typeof props.updateValue === 'function') {
                props.updateValue(
                    otp.map((ele: string, _index: number) => (_index === index ? value : ele)),
                );
            }
            if (index < 5 && value) {
                ref.current[index + 1].focus();
            }
        }
    };

    const handleKeyDown = (index: number) => (event: any) => {
        // let index = otp.filter((ele: string) => !!ele).length;
        if (event.key == 'Backspace' || event.key === 'Delete') {
            if (!otp[index]) {
                if (!(index - 1 < 0)) {
                    props.updateValue(
                        otp.map((ele: string, _index: number) => (_index === index ? '' : ele)),
                    );
                    ref.current[index - 1].focus();
                }
            }
        }
    };

    return (
        <div className="otp-field">
            <h6 id={groupLabelId}>{common.otpinput}</h6>
            <div className="otp-inputs" role="group" aria-labelledby={groupLabelId}>
                {otp.map((ele: string, index: number) => {
                    const inputId = `${otpIdPrefix}-digit-${index + 1}`;

                    const digitLabel = `Digit ${index + 1} of ${OTP_LENGTH}`;
                    return (
                        <Fragment key={index}>
                            <label htmlFor={inputId} className="sr-only">
                                {digitLabel}
                            </label>
                            <TextField
                                id={inputId}
                                inputRef={(el) => (ref.current[index] = el)}
                                disabled={disabled}
                                focused={ref.current === index}
                                onChange={({ target: { value } }) => otpChange(value, index)}
                                onKeyDown={handleKeyDown(index)}
                                value={ele}
                                variant="filled"
                                inputProps={{
                                    inputMode: 'numeric',
                                    'aria-label': digitLabel,
                                }}
                            />
                        </Fragment>
                    );
                })}
            </div>
            {formik?.touched?.otp && formik?.errors?.otp && (
                <p
                    style={{
                        color: '#f44336',
                        fontSize: '12px',
                        fontFamily: 'Montserrat-Medium',
                        paddingLeft: '10px',
                    }}
                >
                    {formik.errors.otp}
                    {''}
                </p>
            )}
            <NoteModals
                showModal={showModal}
                heading={dashboard.UpdateForm15.pleaseNote}
                info={
                    maskedInfo
                        ? maskedInfo
                        : `Please enter the 6-digit OTP sent to ${
                              userRegisteredWith === REGISTER_WITH_MOBILE
                                  ? maskMobileNumber(mobile)
                                  : `*****@${email?.split('@')[1] || '******@***'}`
                          }`
                }
                proceedBtn={'Okay'}
                onProceed={_handleProceed}
            />
        </div>
    );
}

export function ResendOtp({ startTimer = true, counter = 10, onResendOtp, ...props }: any) {
    const [announcementMessage, setAnnouncementMessage] = useState<string>('');
    const [announcementKey, setAnnouncementKey] = useState<number>(0);
    const prevCounter = usePrevious(counter);
    const prevStartTimer = usePrevious(startTimer);

    // Track when timer restarts (OTP resent)
    useEffect(() => {
        // Timer just restarted (was false/not running, now true)
        if (startTimer && prevStartTimer === false) {
            setAnnouncementKey((prev) => prev + 1);
            setAnnouncementMessage('New OTP has been sent.');
        }
    }, [startTimer, prevStartTimer]);

    // Track important countdown milestones
    useEffect(() => {
        if (!startTimer) {
            // Timer just expired
            if (prevStartTimer === true) {
                setAnnouncementKey((prev) => prev + 1);
                setAnnouncementMessage('OTP has expired. You can now resend OTP.');
            }
            return;
        }

        // Announce at specific intervals (only when counter actually changes to these values)
        if (counter !== prevCounter) {
            if (counter === 30) {
                setAnnouncementKey((prev) => prev + 1);
                setAnnouncementMessage('OTP expires in 30 seconds.');
            } else if (counter === 10) {
                setAnnouncementKey((prev) => prev + 1);
                setAnnouncementMessage('OTP expires in 10 seconds.');
            } else if (counter === 5) {
                setAnnouncementKey((prev) => prev + 1);
                setAnnouncementMessage('OTP expires in 5 seconds.');
            }
        }
    }, [counter, prevCounter, startTimer, prevStartTimer]);

    const onResend = () => {
        if (!!onResendOtp && typeof onResendOtp === 'function') {
            onResendOtp();
        }
    };

    return (
        <p className="resend_otp">
            {startTimer ? (
                <>
                    {common.resendotp}
                    <span aria-hidden="true"> {counter}s</span>
                </>
            ) : (
                <>
                    {common.didntReceiveotp}{' '}
                    <a
                        role="button"
                        tabIndex={0}
                        aria-label="Resend OTP"
                        onClick={onResend}
                        onKeyDown={(e: React.KeyboardEvent) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onResend();
                            }
                        }}
                    >
                        {common.resendtext}
                    </a>
                </>
            )}
            {/* Visually hidden live region for screen reader announcements */}
            <span
                key={announcementKey}
                role="status"
                aria-live="polite"
                aria-atomic="true"
                style={{
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    padding: 0,
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0,
                }}
            >
                {announcementMessage}
            </span>
        </p>
    );
}

export function useTimer({ initcounter = 60, initStart = true }) {
    const [timer, setTimer] = useState<number>(initcounter);
    const [startTimer, setTimerStart] = useState<boolean>(initStart);
    const interval = useRef<any>(null);

    const resetTimer = useCallback(() => {
        clearInterval(interval.current);
        setTimer(initcounter);
        setTimerStart(initStart);
    }, [initcounter, initStart]);

    const stopTimer = useCallback(() => {
        clearInterval(interval.current);
        setTimerStart(false);
    }, []);

    useEffect(() => {
        if (timer < 1) {
            setTimerStart(false);
            return;
        }
        if (startTimer) {
            interval.current = setInterval(() => setTimer((timer) => timer - 1), 1000);
        }
        return () => clearInterval(interval.current);
    }, [timer, startTimer]);

    return {
        timer,
        startTimer,
        setTimerStart,
        resetTimer,
        stopTimer,
    };
}
